<ion-content>
  <ion-fab vertical="top" horizontal="start">
    <ion-icon name="arrow-round-back" class="close-fab" [routerLink]="['/welcome']" routerDirection="back"></ion-icon>
  </ion-fab>
  <div class="background-gradient-blue">
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-no-padding">
        <div class="gift-papers">
          <h1 class="heading-text-white">{{'setup-complete.all' | translate}}</h1>
          <p class="sub-heading-white">
            {{'setup-complete.amount' | translate}}
          </p>
        </div>
      </ion-row>
    </ion-grid>
    <div class="content-wrapper">
      <div>
        <div class="invitation-card">
          <ion-grid class="ion-no-padding">
            <div>
              <ion-row class="syndicate-detail-header">
                <ion-col size="8" class="invitation-header">
                  <h2 class="user-syndicate"> {{'setup-complete.syndicate' | translate}}</h2>
                </ion-col>
                <ion-col size="4" class="invitation-header">
                  <h1 class="weekly-price">&#163;6.5/wk</h1>
                </ion-col>
              </ion-row>
            </div>
            <ion-row>
              <img class="invitation-card-image" src="../../../assets/images/toms_syndicate.png" alt="syndicate" />
            </ion-row>
            <div>
              <ion-row>
                <app-expandable [expandHeight]="calculateItemHeight(mockResponse)" expanded="true">
                  @for (syndicate of mockResponse; track syndicate; let jackpotIndex = $index; let lastItem = $last) {
                    <ion-row class="jackpot-container syndicate-row-height"
                      [ngClass]="!lastItem ? 'splitter-line-bottom': ''">
                      <ion-col size="2" class="vertical-center">
                        @if (jackpotIndex === 0) {
                          <img class="jackpot-logo"
                            src="../../../assets/icon/euro_millions_logo.png" alt="euromillion" />
                        }
                        @if (jackpotIndex !== 0) {
                          <img class="jackpot-logo"
                            src="https://ecommercelive.s3.amazonaws.com/wp-content/uploads/app_assets/megamillions_ball.png "
                            alt="megamillion" />
                        }
                      </ion-col>
                      <ion-col size="6" class="vertical-center">
                        <h3 class="jackpot-name">{{ syndicate?.name }}</h3>
                        <p class="lines-available">{{ syndicate?.day }}</p>
                      </ion-col>
                      <ion-col size="4">
                        <h1 class="jackpot-count">x{{ syndicate?.count }}</h1>
                      </ion-col>
                    </ion-row>
                  }
                </app-expandable>
              </ion-row>
            </div>
          </ion-grid>
        </div>
      </div>
    </div>
  </div>
  <div class="page-background-blue">
    <div>
      <h1 class="link-text-blue view-syndicate-agreement" (click)="showSyndicateSummary()">{{'setup-complete.View' |
      translate}}</h1>
      <ion-button expand="block" color="secondary" class="capsule-btn">{{'setup-complete.Join' | translate}}
      </ion-button>
    </div>
  </div>
</ion-content>